





















































import Vue from 'vue';

import { BButton } from 'bootstrap-vue';
import Draggable from 'vuedraggable';

import { mapActions, mapGetters } from '@/state/modules/survey_builder';

import Question from './Question.vue';
import QuestionsPagination from './QuestionsPagination.vue';

export default Vue.extend({
  name: 'Questions',
  components: {
    BButton,
    Draggable,
    Question,
    QuestionsPagination,
  },
  computed: {
    ...mapGetters({
      surveyId: 'surveyId',
      isWeighted: 'isWeighted',
      questionsCount: 'questionsCount',
      questions: 'currentQuestions',
      activeQuestionId: 'activeQuestionId',
      currentPage: 'currentPage',
    }),
  },
  watch: {
    currentPage() {
      (this.$refs.questionsContainer as Vue).$el.scrollTo(0, 0);
    },
  },
  methods: {
    ...mapActions(['editQuestion', 'addQuestion', 'setQuestionsOrder', 'removePage']),
  },
});
